import { render, staticRenderFns } from "./QuickReplyTemplate.vue?vue&type=template&id=33185906&"
import script from "./QuickReplyTemplate.vue?vue&type=script&lang=js&"
export * from "./QuickReplyTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports